import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom"
import styles from './BadgeScannerImageManager.module.css'

// ------ Services ------ //
import * as badgeManagementService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'

// components - form
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import CustomFormula from '../../../components/Badging/BadgeScannerImageManager/CustomFormula'
import ThirdPartyFormula from '../../../components/Badging/BadgeScannerImageManager/ThirdPartyFormula'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'
const BadgeScannerImageManager = () => {

    // State
    const [qrCodeChoicesList, setQrCodeChoicesList] = useState([])
    const [qrCodeThirdPartyFormulaList, setQrCodeThirdPartyFormulaList] = useState([])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(false)
    // useLocation & useNavigate --- Client state from previous page
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const [formData, setFormData] = useState({
        clientId: clientEventInfo.clientId,
        eventId: clientEventInfo.eventId,
        //QRCodeFormula: null, // custom formula
        //{qrCodeFormula: '%ScannerField%', qRChoice: 0, existingFormulas: 0, active: false, createdDate: '2024-04-29T23:11:51.3089929', �}
        qrChoice: null,//dropdown selection to use custom or thirdparty
        scannerImageSetup: 'Barcode', // radio selection for using barcode or qrcode
        //existingFormula: null, // thirdparty selection
        active:true, // control usage of qrcode, incase want it configured but not used
    })
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    const scannerImageSelectionCheck = option => {
        if (document.getElementById('barCheck').checked) {
            document.getElementById('ifBar').style.display = 'block';
            document.getElementById('ifQR').style.display = 'none';
        } else {
            document.getElementById('ifBar').style.display = 'none';
            document.getElementById('ifQR').style.display = 'block';
        }
    };
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }

    const [customFormulaConfig, setCustomFormula] = useState({
        qrCodeFormula: "RegistrationId=%ScannerField%" // default to example
    })

    const [thirdPartyConfig, setThirdPartyFormula] = useState({
        existingFormula: null,
        localEventId: null
    })

    const clearCustomFormulaConfig = () => setCustomFormula({
        qrCodeFormula: "RegistrationId=%ScannerField%"
    })

    const clearThirdPartyFormula = () => setThirdPartyFormula({
        existingFormula: null,
        localEventId: null
    })

    // Ensures state resets if user selects different qrchoice after partially filling out another
    const clearAllForms = () => {
        clearCustomFormulaConfig()
        clearThirdPartyFormula()
    }

    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
            formData.active = !formData.active
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
        
    }

    const appendQrCodeFields = () => {
        // meant to attach all fields to object, before post
        const qrc = formData.qrChoice;
        if (qrc === "Custom") {
            formData.qrCodeFormula = customFormulaConfig.qrCodeFormula
        }
        else if (qrc === "ThirdParty") {
            formData.existingFormula = thirdPartyConfig.existingFormula
            formData.localEventId = thirdPartyConfig.localEventId
        }

        //result = qrc === "Custom" ? { ...customFormulaConfig, qrFormula }
        //    : qrc === "ThirdParty" ?
        //        { ...thirdPartyConfig, existingFormula: existingFormula, localEventId : localEventId }
        //        : console.log("Error: No QrCode formula data provided")

        return formData
    }
    const handleSave= async e => {
        e.preventDefault()

        const appended = await appendQrCodeFields()

        // console.log(appended)

        // call back end service here to POST form data
        try {
            badgeManagementService.saveScannerImageSetup(appended)
        } catch (err) {
            console.log(err)
        }
        clearAllForms();
      
    }
    const handleSaveAndNavigate = async e => {
        e.preventDefault()
        await handleSave()
        navigate(`/BadgeTemplateManager`, { state: clientEventInfo })
    }

    // Catch client setting fetch and feed into form whenever load finishes
    //useEffect(() => {
    //    appendQrCodeFields()
    //}, [formData.qRChoice]) // trigger when qRChoice changes
    useEffect(() => {
        if (formData.scannerImageSetup ===undefined && formData.qrChoice === undefined) {
            return;
        }
        if (formData.scannerImageSetup = "Barcode") {
            setContinueButtonVisibility(true)
        }
        else {
            const qrc = formData.qrChoice;
            if (qrc === "Custom" || qrc === 0) {
                if (formData.qrCodeFormula !== undefined) {
                    setContinueButtonVisibility(true)
                }
                else {
                    setContinueButtonVisibility(false)
                }
            }
            else if (qrc === "ThirdParty" || qrc === 1) {
                if (formData.existingFormula !== undefined && formData.localEventId !== undefined) {
                    setContinueButtonVisibility(true)
                }
                else {
                    setContinueButtonVisibility(false)
                }
            }
        }
        
    }, [formData.qRChoice, formData.qrCodeFormula, formData.existingFormula, formData.localEventId ]) // trigger when qRChoice changes

    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName) {
            const fetchQrCodeThirdPartyFormula = async () => {
                const qrFormulas = await badgeManagementService.getQrCodeThirdPartyFormula()
                //console.log("qrcodeFormula are: ", qrFormulas)
                setQrCodeThirdPartyFormulaList(qrFormulas)
            }
            //getQrCodeChoices
            const fetchQrCodeChoices = async () => {
                const qrcodeChoices = await badgeManagementService.getQrCodeChoices()
              //  console.log("qrcodeChoices are: ", qrcodeChoices)
                setQrCodeChoicesList(qrcodeChoices)
            }
            const fetchSetupData = async () => {
                const getReqBody = await createRequestBody()
                const scannerImageSetup = await badgeManagementService.getScannerImageSetup(getReqBody)
                if (scannerImageSetup) {
                    if (scannerImageSetup.scannerImageSetup === 0 || scannerImageSetup.scannerImageSetup === undefined) {
                        // use barcode
                        scannerImageSetup.scannerImageSetup = "Barcode";
                        document.getElementById('barCheck').checked = true;
                        document.getElementById('ifBar').style.display = 'block';
                        document.getElementById('ifQR').style.display = 'none';
                    }
                    else {
                        // use qrcode
                        scannerImageSetup.scannerImageSetup = "QrCode";
                        document.getElementById('qrCheck').checked = true;
                        document.getElementById('ifBar').style.display = 'none';
                        document.getElementById('ifQR').style.display = 'block';
                    }
                    if (scannerImageSetup.qrChoice !== undefined) {
                        // probably better way to handle, but switch to text
                        if (scannerImageSetup.qrChoice === 0) {
                            scannerImageSetup.qrChoice = "Custom";
                        }
                        else {
                            scannerImageSetup.qrChoice = "ThirdParty";
                        }
                    }

                    setFormData(scannerImageSetup)
                    setCustomFormula(scannerImageSetup)
                    setThirdPartyFormula(scannerImageSetup)
                }
                else {
                    formData.scannerImageSetup = "Barcode";
                    document.getElementById('barCheck').checked = true;
                    document.getElementById('ifBar').style.display = 'block';
                    document.getElementById('ifQR').style.display = 'none';
                    setFormData(formData)
                }
            }
            fetchQrCodeThirdPartyFormula()
            fetchQrCodeChoices()
            fetchSetupData()
        }
        
    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
                formData.clientId = clientEventInfoRef.current.clientId
                formData.eventId = clientEventInfoRef.current.eventId
                setFormData(formData)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
            formData.clientId = passedData.clientId
            formData.eventId = passedData.eventId
            setFormData(formData)
        }
    }, [])
    return (
        <div>
            <h1>Badge QrCode Manager</h1>
            <h2>*Note: ScannerField must be mapped in Badge to ERS Property Mapping.<br />
                Only use if intent on using Barcodes or QrCodes! </h2>

            <div
                className={styles.container}
            >
                <div className={styles.inputContainer}>
                    <label
                        htmlFor="active"
                        className={styles.label}
                    >
                        Active
                        <HoverButton
                            title={'Control usage of setup\ntrue: use setup\nfalse: do not use setup'}
                            messageWidth={350}
                        />
                        :
                    </label>
                    <input
                        type="checkbox"
                        value={formData.active}
                        checked={formData.active}
                        name="active"
                        onChange={handleChange}
                    />
                </div>
                <div className={styles.scannerImageForm}>
                    Select Header/Sponsor or Background Image Use:
                    <HoverButton
                        title={'Use Barcodes = Use barcodes\nUse QR codes = use QR codes'}
                        messageWidth={350}
                    />
                    <br />
                    <label htmlFor="barCheck">
                        <input type="radio" onClick={scannerImageSelectionCheck} name="reloadSelection" id="barCheck" />Use Barcodes
                    </label>
                    <label htmlFor="qrCheck">
                        <input type="radio" onClick={scannerImageSelectionCheck} name="reloadSelection" id="qrCheck" />Use QR codes
                    </label>
                    <br />
                    <br />
                    <div id="ifBar" >
                        <BackSaveContinueButton
                            continueButtonVisibility={continueButtonVisibility}
                            handleSaveAndNavigate={handleSaveAndNavigate}
                            handleSave={handleSave}
                            styles={styles}
                            navigate={navigate}
                        />
                    </div>
                    <div id="ifQR" >
                        <label
                            htmlFor="qrChoice"
                            className={styles.label}
                        >
                            Algorithm Choice
                            <HoverButton
                                title={'Custom = Use CSSField names to create own formula\nThirdparty = known/coded formulas'}
                                messageWidth={150}
                            />
                            :
                        </label>

                        <select
                            name="qrChoice"
                            id={styles.ThirdPartyListDropdown}
                            value={formData.qrChoice}
                            onChange={handleChange}
                        >
                            <option disabled={true} value="" selected="selected">
                                -- Select an option --
                            </option>
                            {
                                qrCodeChoicesList.map((qrCodeChoice, idx) => (
                                    <option key={idx}>{qrCodeChoice.name}</option>
                                ))
                            }
                        </select>
                        {formData.qrChoice === "Custom" ?
                            <CustomFormula
                                formData={formData}
                                qrCodeCustomFormulaForm={customFormulaConfig}
                                setQrCodeCustomFormula={setCustomFormula}
                            />
                            : <></>
                        }
                        {formData.qrChoice === "ThirdParty" ?
                            <ThirdPartyFormula
                                formData={formData}
                                qrCodeThirdPartyFormula={thirdPartyConfig}
                                setQrCodeThirdPartyFormula={setThirdPartyFormula}
                                ThirdPartyList={qrCodeThirdPartyFormulaList}
                            />
                            : <></>
                        }
                        <br /> <br />
                        <BackSaveContinueButton
                            continueButtonVisibility={continueButtonVisibility}
                            handleSaveAndNavigate={handleSaveAndNavigate}
                            handleSave={handleSave}
                            styles={styles}
                            navigate={navigate}
                        />
                        <br />

                    </div>
                   
                </div>
                
            </div>
        </div>

    );
}

export default BadgeScannerImageManager;